import { forwardRef } from 'react';
import { BtnWithHoverLabel } from './btn-with-hover-label.component';
import { StyledIconBtn } from './styled-icon-btn.component';
import { IconButtonProps } from './types';

/** @deprecated Instead, please use `<Button iconName="some icon name">` from `@frontend/design-system` */
export const IconButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  ({ showLabelOnHover, size = 'normal', showLabelAlways = false, type, ...props }, ref) => {
    return showLabelOnHover ? (
      <BtnWithHoverLabel size={size} showLabelAlways={showLabelAlways} type={type} {...props} ref={ref} />
    ) : (
      <StyledIconBtn
        size={size}
        showLabelAlways={showLabelAlways}
        type={type}
        {...props}
        aria-label={props['aria-label'] || `${props.label}`}
        ref={ref}
      />
    );
  }
);
IconButton.displayName = 'IconButton';
